import { useEffect, useRef } from 'react';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 100];

/**
 * 17:1181 — one event per depth threshold crossed downward, at most once per
 * threshold per gate load. `sections` must be ordered top-to-bottom: the
 * deepest one whose top edge entered the viewport becomes `scroll_to`, and the
 * previous `scroll_to` becomes the next event's `scroll_from`.
 */
export const useGateScrollBi = _ref => {
  let {
    containerRef,
    sections
  } = _ref;
  const sectionsRef = useRef(sections);
  const loadedAtRef = useRef(Date.now());
  const firedThresholdsRef = useRef(new Set());
  const lastSectionRef = useRef('searchbar');
  sectionsRef.current = sections;
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const resolveDeepestVisibleSection = () => {
      const viewportBottom = container.getBoundingClientRect().bottom;
      return sectionsRef.current.reduce((deepest, _ref2) => {
        var _ref$current;
        let {
          section,
          ref
        } = _ref2;
        const top = (_ref$current = ref.current) == null ? void 0 : _ref$current.getBoundingClientRect().top;
        return top !== undefined && top < viewportBottom ? section : deepest;
      }, lastSectionRef.current);
    };
    const handleScroll = () => {
      const {
        scrollTop,
        clientHeight,
        scrollHeight
      } = container;
      const scrollDepth = Math.min(100, (scrollTop + clientHeight) / scrollHeight * 100);
      const crossedThresholds = SCROLL_DEPTH_THRESHOLDS.filter(threshold => scrollDepth >= threshold && !firedThresholdsRef.current.has(threshold));
      if (!crossedThresholds.length) {
        return;
      }
      const scrollFrom = lastSectionRef.current;
      const scrollTo = resolveDeepestVisibleSection();
      const timeToScrollMs = Date.now() - loadedAtRef.current;
      const isScrollable = scrollHeight > clientHeight;
      crossedThresholds.forEach(threshold => {
        firedThresholdsRef.current.add(threshold);
        DomainSearchGateModule.internals.bi.onGateScroll == null || DomainSearchGateModule.internals.bi.onGateScroll({
          scrollDepth: threshold,
          scrollFrom,
          scrollTo,
          timeToScrollMs,
          isScrollable,
          viewportHeight: clientHeight
        });
      });
      lastSectionRef.current = scrollTo;
    };
    container.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [containerRef]);
};
//# sourceMappingURL=useGateScrollBi.js.map